import Button from './Button'

export interface BreadcrumbItem {
    id: number
    name: string
}

export interface BreadcrumbsProps {
    items: BreadcrumbItem[]
    onNavigate?: (id: BreadcrumbItem['id']) => void
}

export function Breadcrumbs({ items, onNavigate }: BreadcrumbsProps) {
    if (!items || items.length === 0) return null

    return (
        <ol aria-label="Breadcrumb" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', listStyle: 'none', padding: 0, margin: 0, marginLeft: -4 }}>
            {items.map((item, idx) => {
                const isLast = idx === items.length - 1
                return (
                    <li key={item.id} style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            variant="plain"
                            size="tiny"
                            onClick={() => onNavigate?.(item.id)}
                            disabled={isLast || !onNavigate}
                        >
                            {item.name}
                        </Button>
                        {!isLast && <span style={{ margin: '0 4px' }}>/</span>}
                    </li>
                )
            })}
        </ol>
    )
}
